import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ObAffordabilityModel } from 'src/app/models/ob-affordability.model';

@Component({
  selector: 'app-apg-select-premium-day',
  templateUrl: './apg-select-premium-day.component.html',
  styleUrls: ['./apg-select-premium-day.component.scss'],
})
export class ApgSelectPremiumDayComponent implements OnInit {
  @Input() days: ObAffordabilityModel[];
  @Output() continue = new EventEmitter<number>();

  day: number;
  hasDays: boolean;

  constructor() {

  }

  ngOnInit() {
    this.hasDays = this.days?.length > 0;
  }

  save(day: ObAffordabilityModel) {
    this.day = day.day;
  }

  proceed() {
    this.continue.emit(this.day);
  }
}
